export enum UnderwritingResultStatus {
    Declined = 'declined',
    Preapproved = 'preapproved',
    Approved = 'approved',
    ManualReview = 'manual-review',
}
